import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { userManagementBaseUrl } from "../../redux-toolkit/endpoints";
import { Switch, Table } from "antd";
import {
    SPECIES_REGISTRY_COLUMN,
    METHOD_LIBRARY_COLUMN,
    RISK_MATERIALITY_LOG_COLUMN,
    EMISSIONS_LEDGER_COLUMN,
    AUDIT_DISCLOSURE_SNAPSHOT_COLUMN,
    CARBON_PROJECT_COLUMNS,
    EMISSION_FACTOR_COLUMN,
} from "../constant/AppConstant";
import { BsPlus, BsSearch, BsPencilSquare, BsFileEarmarkPdf } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// ── BRSR Services ──────────────────────────────────────
import {
    useDeleteSpeciesRegistryMutation,
    useGetAllSpeciesRegistryMutation,
} from "../../redux-toolkit/services/speciesRegistryService";
import {
    useDeleteMethodLibraryMutation,
    useGetAllMethodLibraryMutation,
} from "../../redux-toolkit/services/methodLibraryService";
import {
    useDeleteRiskMaterialityLogMutation,
    useGetAllRiskMaterialityLogMutation,
} from "../../redux-toolkit/services/riskMaterialityLogService";
import {
    useDeleteEmissionsLedgerMutation,
    useGetAllEmissionsLedgerMutation,
} from "../../redux-toolkit/services/emissionsLedgerService";
import {
    useDeleteAuditDisclosureSnapshotMutation,
    useGetAllAuditDisclosureSnapshotMutation,
} from "../../redux-toolkit/services/auditDisclosureSnapshotService";
import {
    useDeleteCarbonProjectMutation,
    useSearchCarbonProjectsMutation,
} from "../../redux-toolkit/services/carbonProjectService";
import {
    useDeleteEmissionFactorMutation,
    useFindAllEmissionFactorsMutation,
} from "../../redux-toolkit/services/emissionFactorService";

// ── BRSR Slices ────────────────────────────────────────
import {
    getAllSpeciesRegistryDetails,
    getSpeciesRegistryTotalRecords,
    setSpeciesRegistry,
} from "../../redux-toolkit/slices/speciesRegistrySlice";
import {
    getAllMethodLibraryDetails,
    getMethodLibraryTotalRecords,
    setMethodLibrary,
} from "../../redux-toolkit/slices/methodLibrarySlice";
import {
    getAllRiskMaterialityLogDetails,
    getRiskMaterialityLogTotalRecords,
    setRiskMaterialityLog,
} from "../../redux-toolkit/slices/riskMaterialityLogSlice";
import {
    getAllEmissionsLedgerDetails,
    getEmissionsLedgerTotalRecords,
    setEmissionsLedger,
} from "../../redux-toolkit/slices/emissionsLedgerSlice";
import {
    getAllAuditDisclosureSnapshotDetails,
    getAuditDisclosureSnapshotTotalRecords,
    setAuditDisclosureSnapshot,
} from "../../redux-toolkit/slices/auditDisclosureSnapshotSlice";
import {
    getAllCarbonProjectsDetails,
    getCarbonProjectsTotalRecords,
    setCarbonProject,
} from "../../redux-toolkit/slices/carbonProjectSlice";
import {
    selectAllEmissionFactors,
    setEmissionFactors,
} from "../../redux-toolkit/slices/emissionFactorSlice";

import BSRLComplianceData from "./BSRLComplianceData";

const BSRLCompliance = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");

    const [actionType, setActionType] = useState<ACTION_TYPE>(ACTION_TYPE.ADD_ACTION);
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any>(null);

    // Mutations
    const [getAllSpecies, allSpeciesRes] = useGetAllSpeciesRegistryMutation();
    const [deleteSpecies, deleteSpeciesRes] = useDeleteSpeciesRegistryMutation();

    const [getAllMethod, allMethodRes] = useGetAllMethodLibraryMutation();
    const [deleteMethod, deleteMethodRes] = useDeleteMethodLibraryMutation();

    const [getAllRisk, allRiskRes] = useGetAllRiskMaterialityLogMutation();
    const [deleteRisk, deleteRiskRes] = useDeleteRiskMaterialityLogMutation();

    const [getAllEmission, allEmissionRes] = useGetAllEmissionsLedgerMutation();
    const [deleteEmission, deleteEmissionRes] = useDeleteEmissionsLedgerMutation();

    const [getAllSnapshot, allSnapshotRes] = useGetAllAuditDisclosureSnapshotMutation();
    const [deleteSnapshot, deleteSnapshotRes] = useDeleteAuditDisclosureSnapshotMutation();

    const [searchProjects, searchProjectsRes] = useSearchCarbonProjectsMutation();
    const [deleteProject, deleteProjectRes] = useDeleteCarbonProjectMutation();
    const [findAllEmissionFactors, findAllEmissionFactorsRes] = useFindAllEmissionFactorsMutation();
    const [deleteEmissionFactor, deleteEmissionFactorRes] = useDeleteEmissionFactorMutation();

    // Selectors
    const allSpecies: any = useAppSelector(getAllSpeciesRegistryDetails);
    const totalSpecies: any = useAppSelector(getSpeciesRegistryTotalRecords);

    const allMethod: any = useAppSelector(getAllMethodLibraryDetails);
    const totalMethod: any = useAppSelector(getMethodLibraryTotalRecords);

    const allRisk: any = useAppSelector(getAllRiskMaterialityLogDetails);
    const totalRisk: any = useAppSelector(getRiskMaterialityLogTotalRecords);

    const allEmission: any = useAppSelector(getAllEmissionsLedgerDetails);
    const totalEmission: any = useAppSelector(getEmissionsLedgerTotalRecords);

    const allSnapshot: any = useAppSelector(getAllAuditDisclosureSnapshotDetails);
    const totalSnapshot: any = useAppSelector(getAuditDisclosureSnapshotTotalRecords);

    const allProjects: any = useAppSelector(getAllCarbonProjectsDetails);
    const totalProjects: any = useAppSelector(getCarbonProjectsTotalRecords);
    const allEmissionFactors: any = useAppSelector(selectAllEmissionFactors);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.SPECIES_REGISTRY: setReportName(REPORT_NAME.SPECIES_REGISTRY); break;
            case REPORT_PATH.METHOD_LIBRARY: setReportName(REPORT_NAME.METHOD_LIBRARY); break;
            case REPORT_PATH.RISK_MATERIALITY_LOG: setReportName(REPORT_NAME.RISK_MATERIALITY_LOG); break;
            case REPORT_PATH.EMISSIONS_LEDGER: setReportName(REPORT_NAME.EMISSIONS_LEDGER); break;
            case REPORT_PATH.AUDIT_DISCLOSURE_SNAPSHOT: setReportName(REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT); break;
            case REPORT_PATH.CARBON_PROJECT_MASTER: setReportName(REPORT_NAME.CARBON_PROJECT_MASTER); break;
            case REPORT_PATH.EMISSION_FACTOR_MASTER: setReportName(REPORT_NAME.EMISSION_FACTOR_MASTER); break;
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "action",
            fixed: "right",
            width: 150,
            render: (index: any, record: any) => (
                <div className="d-flex justify-content-between">
                    <div className="px-2 pe-auto">
                        <Switch
                            className={`${record.status === true ? "bg-accent" : "bg-secondry"}`}
                            checked={record.status === true}
                            onChange={() => {
                                if (record.status === true) {
                                    setSelectedRecord(record);
                                    setShowDeleteModal(true);
                                } else {
                                    onDeleteData(record, "activate");
                                }
                            }}
                        />
                    </div>
                    {record.status === true && (
                        <div className="px-2 pe-auto cursor-pointer" onClick={() => handleOpenForm(record)}>
                            <BsPencilSquare size={18} />
                        </div>
                    )}
                    {reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT && record.status === true && (
                        <div className="px-2 pe-auto cursor-pointer" onClick={() => handleDownloadPdf(record)}>
                            <BsFileEarmarkPdf size={18} title="Download PDF" />
                        </div>
                    )}
                </div>
            ),
        };

        let baseCols: any[] = [];
        if (reportName === REPORT_NAME.SPECIES_REGISTRY) baseCols = SPECIES_REGISTRY_COLUMN;
        else if (reportName === REPORT_NAME.METHOD_LIBRARY) baseCols = METHOD_LIBRARY_COLUMN;
        else if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) baseCols = RISK_MATERIALITY_LOG_COLUMN;
        else if (reportName === REPORT_NAME.EMISSIONS_LEDGER) baseCols = EMISSIONS_LEDGER_COLUMN;
        else if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) baseCols = AUDIT_DISCLOSURE_SNAPSHOT_COLUMN;
        else if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) baseCols = CARBON_PROJECT_COLUMNS;
        else if (reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) baseCols = EMISSION_FACTOR_COLUMN;

        if (baseCols) {
            baseCols.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName]);

    const fetchData = (page: number, size: number) => {
        const payload = { pageNumber: page - 1, offset: size, searchTerm };
        const token = localUserObj?.token;
        if (reportName === REPORT_NAME.SPECIES_REGISTRY) getAllSpecies({ token, payload });
        else if (reportName === REPORT_NAME.METHOD_LIBRARY) getAllMethod({ token, payload });
        else if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) getAllRisk({ token, payload });
        else if (reportName === REPORT_NAME.EMISSIONS_LEDGER) getAllEmission({ token, payload });
        else if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) getAllSnapshot({ token, payload });
        else if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) searchProjects(payload);
        else if (reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) findAllEmissionFactors({ token });
    };

    useEffect(() => { if (reportName) fetchData(currentpage, pageSize); }, [reportName]);
    useEffect(() => { if (call === "Y") { fetchData(currentpage, pageSize); setCall("N"); } }, [call]);

    const paginationChange = (page: number, size: number) => {
        setCurrentPage(page);
        setPageSize(size);
        fetchData(page, size);
    };

    const getRecordName = () => {
        if (reportName === REPORT_NAME.SPECIES_REGISTRY) return "Species Registry";
        if (reportName === REPORT_NAME.METHOD_LIBRARY) return "Method Library";
        if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) return "Risk Materiality Log";
        if (reportName === REPORT_NAME.EMISSIONS_LEDGER) return "Emissions Ledger";
        if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) return "Audit Disclosure Snapshot";
        return reportName;
    };

    const onDeleteData = (
        record: any,
        type: "soft" | "hard" | "activate"
    ) => {
        const token = localUserObj?.token;
        const id = record.id;
        let mutationPromise: any;

        if (reportName === REPORT_NAME.SPECIES_REGISTRY) mutationPromise = deleteSpecies({ token, id, type });
        else if (reportName === REPORT_NAME.METHOD_LIBRARY) mutationPromise = deleteMethod({ token, id, type });
        else if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) mutationPromise = deleteRisk({ token, id, type });
        else if (reportName === REPORT_NAME.EMISSIONS_LEDGER) mutationPromise = deleteEmission({ token, id, type });
        else if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) mutationPromise = deleteSnapshot({ token, id, type });
        else if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) deleteProject({ id });
        else if (reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) deleteEmissionFactor({ token, id });
        if (mutationPromise) {
            mutationPromise.unwrap()
                .then(() => {
                    const recName = getRecordName();
                    if (type === "hard") {
                        alertMessage(`${recName} deleted permanently`, "success");
                        setDatasource((prev: any) => prev.filter((item: any) => item.id !== record.id));
                    } else if (type === "soft") {
                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: false }
                                    : item
                            )
                        );
                        alertMessage(`${recName} deleted successfully`, "success");
                        setCall("Y");
                    } else if (type === "activate") {
                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: true }
                                    : item
                            )
                        );
                        alertMessage(`${recName} activated successfully`, "success");
                        setCall("Y");
                    }
                })
                .catch((error: any) => {
                    const errorMsg = error?.data?.message || "Cannot delete this record because it is associated with other records";
                    alertMessage(errorMsg, "error");
                });
        }
    };

    const handleSoftDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "soft");
        }
    };

    const handleDownloadPdf = async (record: any) => {
        const token = localUserObj?.token;
        const id = record.id;
        const reportPeriod = record.reportPeriod || "Record";

        if (!id) {
            alertMessage("Record ID is required to generate PDF", "error");
            return;
        }

        try {
            const base = userManagementBaseUrl || "https://investmgmt.passionit.com/user-management";
            const baseUrl = base.endsWith('/') ? base.slice(0, -1) : base;
            const response = await fetch(`${baseUrl}/auditDisclosureSnapshot/generatePdf/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `BSRL_Report_${reportPeriod}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                alertMessage("Failed to download PDF", "error");
            }
        } catch (error) {
            console.error("Error downloading PDF", error);
            alertMessage("Error downloading PDF", "error");
        }
    };

    // Delete effects
    const handleDeleteResult = (res: any) => {
        if (res.isSuccess) { alertMessage("Status changed successfully", "success"); setCall("Y"); }
        else if (res.isError) alertMessage("Error while updating status", "error");
    };

    useEffect(() => handleDeleteResult(deleteSpeciesRes), [deleteSpeciesRes.isSuccess, deleteSpeciesRes.isError]);
    useEffect(() => handleDeleteResult(deleteMethodRes), [deleteMethodRes.isSuccess, deleteMethodRes.isError]);
    useEffect(() => handleDeleteResult(deleteRiskRes), [deleteRiskRes.isSuccess, deleteRiskRes.isError]);
    useEffect(() => handleDeleteResult(deleteEmissionRes), [deleteEmissionRes.isSuccess, deleteEmissionRes.isError]);
    useEffect(() => handleDeleteResult(deleteSnapshotRes), [deleteSnapshotRes.isSuccess, deleteSnapshotRes.isError]);
    useEffect(() => handleDeleteResult(deleteProjectRes), [deleteProjectRes.isSuccess, deleteProjectRes.isError]);
    useEffect(() => handleDeleteResult(deleteEmissionFactorRes), [deleteEmissionFactorRes.isSuccess, deleteEmissionFactorRes.isError]);

    const handleHardDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "hard");
        }
    };

    const handleOpenForm = (record: any) => { setActionType(ACTION_TYPE.UPDATE_ACTION); setSelectedRow(record); setShow(true); };
    const handleShow = () => { setActionType(ACTION_TYPE.ADD_ACTION); setSelectedRow({}); setShow(true); };

    // Data effects
    useEffect(() => { if (allSpeciesRes.isSuccess) dispatch(setSpeciesRegistry(allSpeciesRes)); }, [allSpeciesRes.isSuccess]);
    useEffect(() => { if (allMethodRes.isSuccess) dispatch(setMethodLibrary(allMethodRes)); }, [allMethodRes.isSuccess]);
    useEffect(() => { if (allRiskRes.isSuccess) dispatch(setRiskMaterialityLog(allRiskRes)); }, [allRiskRes.isSuccess]);
    useEffect(() => { if (allEmissionRes.isSuccess) dispatch(setEmissionsLedger(allEmissionRes)); }, [allEmissionRes.isSuccess]);
    useEffect(() => { if (allSnapshotRes.isSuccess) dispatch(setAuditDisclosureSnapshot(allSnapshotRes)); }, [allSnapshotRes.isSuccess]);
    useEffect(() => { if (searchProjectsRes.isSuccess) dispatch(setCarbonProject(searchProjectsRes)); }, [searchProjectsRes.isSuccess]);
    useEffect(() => { if (findAllEmissionFactorsRes.isSuccess) dispatch(setEmissionFactors(findAllEmissionFactorsRes.data?.data || findAllEmissionFactorsRes.data || [])); }, [findAllEmissionFactorsRes.isSuccess]);

    useEffect(() => { if (reportName === REPORT_NAME.SPECIES_REGISTRY) setDatasource(allSpecies || []); }, [allSpecies, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.METHOD_LIBRARY) setDatasource(allMethod || []); }, [allMethod, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) setDatasource(allRisk || []); }, [allRisk, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.EMISSIONS_LEDGER) setDatasource(allEmission || []); }, [allEmission, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) setDatasource(allSnapshot || []); }, [allSnapshot, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) setDatasource(allProjects || []); }, [allProjects, reportName]);
    useEffect(() => { if (reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) setDatasource(allEmissionFactors || []); }, [allEmissionFactors, reportName]);

    const getTotalRecords = () => {
        if (reportName === REPORT_NAME.SPECIES_REGISTRY) return totalSpecies;
        if (reportName === REPORT_NAME.METHOD_LIBRARY) return totalMethod;
        if (reportName === REPORT_NAME.RISK_MATERIALITY_LOG) return totalRisk;
        if (reportName === REPORT_NAME.EMISSIONS_LEDGER) return totalEmission;
        if (reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) return totalSnapshot;
        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) return totalProjects;
        if (reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) return allEmissionFactors?.length || 0;
        return 0;
    };

    const isLoading = allSpeciesRes.isLoading || allMethodRes.isLoading || allRiskRes.isLoading || allEmissionRes.isLoading || allSnapshotRes.isLoading || searchProjectsRes.isLoading || findAllEmissionFactorsRes.isLoading;

    return (
        <div className="mt-2 overflow-y-auto">
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Body className="text-center pb-0 mt-3">
                    <h5 className="mb-4">Do you want to delete this record permanently?</h5>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center mb-2">
                    <Button variant="danger" onClick={handleHardDelete}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={handleSoftDelete}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>

            {show && (
                <BSRLComplianceData
                    show={show}
                    setShow={setShow}
                    actionType={actionType}
                    reportName={reportName}
                    data={selectedRow}
                    setCall={setCall}
                />
            )}

            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5 className="m-0 px-0 d-flex align-items-center text-accent" style={{ fontWeight: "700" }}>{reportName}</h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100 flex-wrap" style={{ gap: "8px" }}>
                    <div className="d-flex flex-column" style={{ minWidth: "200px" }}>
                        <div className="input-group px-2 mt-1">
                            <Form.Control type="search" placeholder="Search" className="border-0 bg-cm-light-primary1" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0"><BsSearch /></span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button className="d-flex align-items-center me-0 text-nowrap bg-accent border-0" onClick={handleShow}>
                            <BsPlus /> Add
                        </Button>
                    </div>
                    {isLoading && <Loading />}
                </div>
            </div>

            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered
                    rowKey="id"
                    scroll={{ x: "max-content" }}
                    pagination={{
                        total: getTotalRecords(),
                        current: currentpage,
                        pageSize: pageSize,
                        onChange: paginationChange,
                        pageSizeOptions: [10, 20, 30],
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};

export default BSRLCompliance;
